<template>
  <div>
    <div class="elevation-1">
      <v-toolbar flat color="white">
        <v-toolbar-title> REGISTRO DE EVENTOS </v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-toolbar-title :class="`${classChipEvent} overflow-initial`">
          <v-chip :color="colorChipEvent" text-color="white" label>{{
            textChipEvent
          }}</v-chip>
          {{ nameChipEvent }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-progress-linear
          :active="loading"
          :indeterminate="loading"
          absolute
          bottom
          color="deep-purple accent-4"
        ></v-progress-linear>
        <v-spacer></v-spacer>
        <v-btn
          dark
          @click="newEvent"
          color="orange darken-1"
          small
          class="mt-1"
        >
          <v-icon left> mdi-plus </v-icon>
          Novo Evento
        </v-btn>
      </v-toolbar>
      <alert
        :type="typeAlert"
        :visible="showAlert"
        :message="messageAlert"
        :clickClose="() => (showAlert = false)"
      ></alert>
      <v-form ref="form" v-model="valid" :lazy-validation="lazy">
        <v-container fluid>
          <v-row>
            <v-col cols="12" xs="6" sm="3" md="2">
              <v-select
                :items="months"
                v-model="event.month_billing"
                @change="getEvents()"
                label="Mês"
                hide-details
                dense
                outlined
              ></v-select>
            </v-col>
            <v-col cols="12" xs="6" sm="3" md="2">
              <v-select
                :items="years"
                v-model="event.year_billing"
                @change="getEvents()"
                label="Ano"
                hide-details
                dense
                outlined
              ></v-select>
            </v-col>
            <v-col cols="12" xs="12" sm="6" md="4" lg="3">
              <v-select
                :items="events"
                v-model="event_selected"
                :item-text="
                  (item) => {
                    if (item.cancelled == 0) {
                      return `${item.code} - ${item.description.toUpperCase()}`;
                    } else {
                      return `${
                        item.code
                      } - [C] ${item.description.toUpperCase()}`;
                    }
                  }
                "
                item-value="id"
                label="Eventos Registrados"
                @change="handleSelectEvent()"
                hide-details
                dense
                outlined
                @click:clear="handleClickClear"
              ></v-select>
            </v-col>
            <v-col cols="12" xs="12" sm="6" md="4" lg="5">
              <v-text-field
                outlined
                dense
                hide-details
                label="Descrição"
                class="text-field-uppercase"
                v-model="event.description"
                :disabled="disabledFields"
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="6" sm="6" md="3" lg="3">
              <v-select
                :items="types_apportionment"
                v-model="event.type"
                @change="handleChangeApportionment"
                label="Tipo de Rateio"
                hide-details
                dense
                outlined
                :disabled="disabledFields"
              ></v-select>
            </v-col>
            <v-col cols="12" xs="6" sm="4" md="3" lg="2">
              <v-select
                v-if="event.type === 1"
                :items="months"
                v-model="event.month_reference"
                label="Mês Referência"
                hide-details
                dense
                outlined
                :disabled="disabledFields"
              ></v-select>
            </v-col>
            <v-col cols="12" xs="6" sm="4" md="3" lg="2">
              <v-select
                v-if="event.type === 1"
                :items="years_reference"
                v-model="event.year_reference"
                label="Ano Referência"
                hide-details
                dense
                outlined
                :disabled="disabledFields"
              ></v-select>
            </v-col>
            <v-col cols="12" xs="6" sm="4" md="3" lg="2">
              <!-- <v-text-field
                outlined
                dense
                hide-details
                reverse
                label="Valor do Evento"
                v-model="event.value"
                :disabled="disabledFields"
              ></v-text-field> -->
              <v-text-field-money
                v-model="event.value"
                label="Valor do Evento"
                v-bind:properties="{
                  prefix: '',
                  readonly: false,
                  dense: true,
                  hideDetails: true,
                  disabled: disabledFields,
                  outlined: true,
                  clearable: false,
                  placeholder: ' ',
                }"
                v-bind:options="{
                  locale: 'pt-BR',
                  length: 11,
                  precision: 2,
                  empty: null,
                }"
              />
            </v-col>
          </v-row>
          <!-- <v-row> -->
          <!-- <v-col cols="12" xs="6" md="5"> -->
          <!-- <v-file-input
                label="Upload de Arquivos"
                multiple
                outlined
                dense
                counter
                truncate-length="12"
                v-model="files"
                :clearable="false"
              >
                <template v-slot:selection="{ index, text }">
                  <v-chip
                    color="deep-purple accent-4"
                    dark
                    label
                    small
                    close
                    close-icon="mdi-delete"
                    @click="handleFileUpload"
                    @click:close="handleCloseFileUpload(index)"
                  >
                    {{ text }}
                  </v-chip>
                </template>
              </v-file-input> -->
          <!-- </v-col> -->
          <!-- </v-row> -->
          <v-row>
            <v-col cols="12" xs="6" md="6" class="py-1">
              <v-btn
                @click="loadCompanies"
                color="blue darken-3 white--text"
                small
                :disabled="disabledFields"
                class="mt-1"
              >
                <v-icon left> mdi-plus </v-icon>
                Carregar Franqueados
              </v-btn>
            </v-col>
            <v-col xs="6" md="6" class="py-1">
              <v-btn
                :disabled="companies.length === 0 || disabledFields"
                @click="handleCheckAll"
                :color="`${checkAllColor} white--text`"
                small
                outlined
                class="float-right"
                v-if="event.type !== 3"
              >
                <v-icon left> {{ checkAllIcon }} </v-icon>
                {{ checkAllLabel }}
              </v-btn>
              <v-btn
                :disabled="companies.length === 0"
                color="grey darken-4"
                small
                outlined
                @click="exportCompanies('excel')"
                class="float-right mr-3"
              >
                <v-icon color="green" left> mdi-file-excel-box </v-icon>
                Excel
              </v-btn>
              <v-btn
                :disabled="companies.length === 0"
                color="grey darken-4"
                small
                outlined
                @click="exportCompanies('pdf')"
                class="float-right mr-1"
              >
                <v-icon color="red" left> mdi-file-pdf-box </v-icon>
                PDF
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="py-1">
              <v-card>
                <v-toolbar
                  color="blue darken-4"
                  class="font-weight-bold"
                  dense
                  outlined
                  height="28"
                  dark
                  >RATEIO</v-toolbar
                >
                <v-card-text>
                  <v-row>
                    <v-col>
                      <v-simple-table dense fixed-header height="340">
                        <template v-slot:default>
                          <thead>
                            <tr>
                              <th class="text-left text-no-wrap">Filial</th>
                              <th class="text-left text-no-wrap" width="180px">
                                Franqueado
                              </th>
                              <th class="text-left text-no-wrap" width="250px">
                                Cidade/Shopping ou Bairro
                              </th>
                              <th class="text-left text-no-wrap">UF</th>
                              <th class="text-left text-no-wrap">CNPJ</th>
                              <th class="text-left text-no-wrap">
                                (R$) Faturamento
                              </th>
                              <th
                                class="text-left text-no-wrap"
                                v-if="event.type !== 3"
                              >
                                Seleção
                              </th>
                              <th
                                class="text-left text-no-wrap"
                                style="width: 90px"
                                v-if="event.type === 3"
                              >
                                Número de Peças
                              </th>
                              <th class="text-left text-no-wrap">
                                (R$) Cobrado
                              </th>
                              <th class="text-left text-no-wrap">
                                Doc. Faturamento
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="company in companies"
                              :key="company.id"
                              :class="getClassSelected(company)"
                            >
                              <td class="text-center">{{ company.code }}</td>
                              <td>{{ company.name }}</td>
                              <td>{{ company.description }}</td>
                              <td class="text-center">
                                {{ company.delivery_state }}
                              </td>
                              <td class="text-center">
                                {{ company.company_document }}
                              </td>
                              <td class="text-right">
                                {{ company.billing | currencyEuaToBr }}
                              </td>
                              <td
                                class="text-center justify-center"
                                v-if="event.type !== 3"
                              >
                                <v-checkbox
                                  v-model="company.check"
                                  hide-details=""
                                  :true-value="true"
                                  :false-value="false"
                                  :value="company.id"
                                  :disabled="disabledFields"
                                  @click="handleClickSelectCompany(company)"
                                  class="align-self-center"
                                ></v-checkbox>
                              </td>
                              <td
                                class="text-center justify-center"
                                v-if="event.type === 3"
                              >
                                <v-text-field
                                  label=""
                                  outlined
                                  hide-details=""
                                  dense
                                  :disabled="disabledFields"
                                  v-model="company.parts"
                                  class="fs-12"
                                ></v-text-field>
                              </td>
                              <td class="text-right">
                                {{ getAmount(company) | currencyEuaToBr }}
                              </td>
                              <td>
                                {{ company.document }}
                              </td>
                            </tr>
                          </tbody>
                          <tfoot v-if="companies.length > 0">
                            <tr>
                              <th></th>
                              <th colspan="2">
                                Franqueados Selecionados:
                                {{ getCountCompaniesChecked() }} de
                                {{ companies.length }}
                              </th>
                              <th></th>
                              <th></th>
                              <th></th>
                              <th></th>
                              <th class="text-right">
                                {{ getTotal() | currencyEuaToBr }}
                              </th>
                              <th></th>
                            </tr>
                          </tfoot>
                        </template>
                      </v-simple-table>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions>
                  <v-col cols="12" class="py-0">
                    <v-btn
                      color="grey lighten-4"
                      class="float-right"
                      small
                      @click="handleCancelEvent"
                      :disabled="disabledFields"
                    >
                      <v-icon left>mdi-close</v-icon>
                      Cancelar Evento</v-btn
                    >
                    <v-btn
                      color="green darken-3"
                      class="float-right mr-3 white--text"
                      :disabled="disabledFields"
                      @click="handleSaveEvent"
                      small
                    >
                      <v-icon left> mdi-check </v-icon>
                      Gravar Lançamentos
                    </v-btn>
                  </v-col>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </div>
    <v-dialog
      transition="dialog-bottom-transition"
      max-width="400"
      v-model="linkDownload"
    >
      <v-card>
        <v-card-text class="pa-10">
          <v-btn
            class="ma-5 white--text justify-center d-flex"
            large
            color="indigo"
            target="_blank"
            :href="download.link"
            @click="() => (linkDownload = false)"
          >
            <v-icon left>mdi-cloud-download</v-icon>
            CLIQUE AQUI PARA BAIXAR
          </v-btn>
        </v-card-text>
        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="linkDownload = false">
            FECHAR
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogCancelEvent" max-width="500px">
      <v-card>
        <v-toolbar color="red lighten-1" dark class="text-h5"
          >Atenção</v-toolbar
        >
        <v-card-title class="text-h6">
          Tem certeza que deseja Cancelar esse Evento?
        </v-card-title>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeDialogCancelEvent"
            >Fechar</v-btn
          >
          <v-btn color="red darken-1" dark @click="handleCancelEventClick">
            <v-icon dark>mdi-close</v-icon>
            Cancelar Evento
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { URL } from "@/api/config";
import AwesomeMask from "awesome-mask";
import Alert from "@/components/Alert";

export default {
  components: { Alert },
  directives: {
    mask: AwesomeMask,
  },
  data: () => ({
    months: [
      { value: 1, text: "Janeiro" },
      { value: 2, text: "Fevereiro" },
      { value: 3, text: "Março" },
      { value: 4, text: "Abril" },
      { value: 5, text: "Maio" },
      { value: 6, text: "Junho" },
      { value: 7, text: "Julho" },
      { value: 8, text: "Agosto" },
      { value: 9, text: "Setembro" },
      { value: 10, text: "Outubro" },
      { value: 11, text: "Novembro" },
      { value: 12, text: "Dezembro" },
    ],
    years: [],
    years_reference: [],
    events: [],
    event_selected: "",
    event_default: {
      id: "",
      code: "",
      month_billing: "",
      year_billing: "",
      description: "",
      type: 1,
      month_reference: "",
      year_reference: "",
      value: "0.00",
      cancelled: 0,
    },
    event: {
      id: "",
      code: "",
      month_billing: "",
      year_billing: "",
      description: "",
      type: 1,
      month_reference: "",
      year_reference: "",
      value: "0.00",
      cancelled: 0,
    },
    types_apportionment: [
      { value: 1, text: "Faturamento" },
      { value: 2, text: "Número de Lojas" },
      { value: 3, text: "Peças" },
    ],
    companies: [],
    checkAll: false,
    checkAllLabel: "Selecionar Todas",
    checkAllIcon: "mdi-checkbox-marked-outline",
    checkAllColor: "green darken-3",
    loading: false,
    lazy: false,
    valid: true,
    files: [],
    linkDownload: false,
    download: {
      name: "",
      link: "#",
    },
    dialogCancelEvent: false,
    disabledFields: false,
    colorChipEvent: "orange darken-1",
    textChipEvent: "NOVO EVENTO",
    nameChipEvent: "",
    classChipEvent: "",
    showAlert: false,
    typeAlert: "error",
    messageAlert: "",
  }),
  computed: {},
  created() {
    let dateNow = new Date();
    this.event.month_billing = dateNow.getMonth() + 1;
    this.event.year_billing = dateNow.getFullYear();
    this.event_default.month_billing = dateNow.getMonth() + 1;
    this.event_default.year_billing = dateNow.getFullYear();

    let yearNow = dateNow.getFullYear();

    // COLOCA 10 ANOS PARA TRAS
    for (let i = 10; i >= 0; i--) {
      this.years.push(yearNow - i);
    }
    this.years_reference = [...this.years];
    // COLOCA +2 ANOS PARA FRENTE
    for (let i = 1; i <= 2; i++) {
      this.years.push(yearNow + i);
    }

    this.event.year_reference = dateNow.getFullYear();
    this.event.month_reference = dateNow.getMonth() + 1;
    this.event_default.year_reference = dateNow.getFullYear();
    this.event_default.month_reference = dateNow.getMonth() + 1;

    // MONTA O ARRAY INVERTIDO PARA MOSTRAR OS ANOS DESC
    this.years = this.years.reverse();
    this.years_reference = this.years_reference.reverse();

    this.initialize();
  },
  filters: {
    currencyEuaToBr: function (value) {
      if (!value) return "";
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(value);
    },
  },
  methods: {
    async initialize() {
      this.getEvents();
    },
    async getEvents() {
      this.clearEvent();
      // console.log(this.event);
      if (
        this.event === undefined ||
        this.event.month_billing === "" ||
        this.event.year_billing === ""
      ) {
        return false;
      }
      this.loading = true;
      this.events = [];
      try {
        let res = await fetch(
          `${URL}event-log?month=${this.event.month_billing}&year=${this.event.year_billing}`
        );
        if (res.ok) {
          let response = await res.json();
          this.events = response;
          this.events = this.events.map((item) => ({
            ...item,
            month_billing: parseInt(item.month_billing),
            year_billing: parseInt(item.year_billing),
            month_reference: parseInt(item.month_reference),
            year_reference: parseInt(item.year_reference),
          }));
        } else {
          throw new Error(res.message);
        }
      } catch (error) {
        console.log(error.message);
        this.typeAlert = "error";
        this.messageAlert =
          "Não foi possível buscar os eventos desse período, tente novamente mais tarde";
        this.showAlert = true;
      } finally {
        this.loading = false;
      }
    },
    async loadCompanies() {
      this.showAlert = false;
      if (
        this.event === undefined ||
        this.event.month_billing === "" ||
        this.event.year_billing === ""
      ) {
        return false;
      }
      this.loading = true;
      this.companies = [];
      this.linkDownload = false;

      let url = "";
      if (this.event.type == 1) {
        url = `${URL}event-log-company?type=${this.event.type}&month=${this.event.month_reference}&year=${this.event.year_reference}&event_log=${this.event_selected}`;
      } else {
        url = `${URL}event-log-company?type=${this.event.type}&event_log=${this.event_selected}`;
      }

      try {
        let response = await fetch(url);
        let data = await response.json();
        this.companies = data.sort((a, b) => (a.name > b.name ? 1 : -1));

        this.disabledFields =
          this.event.cancelled == 1 ||
          (this.companies.length > 0 &&
            this.companies.find((item) => item.document !== "") != undefined);
        this.changeChipEvent();
      } catch (error) {
        this.companies = [];
        console.log(error.message);
        this.typeAlert = "error";
        this.messageAlert =
          "Não foi possível buscar os dados de Rateio, tente novamente mais tarde";
        this.showAlert = true;
      } finally {
        this.loading = false;
      }
    },
    handleChangeApportionment() {
      this.companies = [];
    },
    handleCheckAll() {
      if (this.companies.filter((i) => i.check != false).length === 0) {
        this.companies = this.companies.map((item) => ({
          ...item,
          check: true,
        }));
        this.checkAllLabel = "Desmarcar Todos";
        this.checkAllIcon = "mdi-checkbox-blank-outline";
        this.checkAllColor = "red darken-3";
      } else {
        this.companies = this.companies.map((item) => ({
          ...item,
          check: false,
        }));
        this.checkAllLabel = "Selecionar Todos";
        this.checkAllIcon = "mdi-checkbox-marked-outline";
        this.checkAllColor = "green darken-3";
      }
    },
    handleClickSelectCompany() {
      if (this.companies.filter((i) => i.check != false).length > 0) {
        this.checkAllLabel = "Desmarcar Todos";
        this.checkAllIcon = "mdi-checkbox-blank-outline";
        this.checkAllColor = "red darken-3";
      } else {
        this.checkAllLabel = "Selecionar Todos";
        this.checkAllIcon = "mdi-checkbox-marked-outline";
        this.checkAllColor = "green darken-3";
      }
    },
    getCountCompaniesChecked() {
      if (this.event.type !== 3) {
        return this.companies.filter((i) => i.check != false).length;
      } else {
        return this.companies.filter((i) => i.parts != 0 && i.parts != "")
          .length;
      }
    },
    validate() {},
    handleFileUpload() {
      // console.log("CLICK FILE");
    },
    handleCloseFileUpload(index) {
      this.files = this.files.filter((item, idx) => index !== idx);
    },
    handleSaveEvent() {
      let newEvent = { ...this.event };
      newEvent.description = newEvent.description.toUpperCase();
      newEvent.value = newEvent.value.replace(/,/gi, ".");
      if (newEvent.id === "") {
        this.post(newEvent);
      } else {
        this.put(this.event.id, newEvent);
      }
    },
    async post(data) {
      this.loading = true;
      try {
        let myHeaders = new Headers({
          "Content-Type": "application/json",
        });
        let res = await fetch(`${URL}event-log`, {
          method: "POST",
          headers: myHeaders,
          body: JSON.stringify(data),
        });
        if (!res.ok) {
          throw new Error(res.message);
        }
        let response = await res.json();
        await this.saveCompanies(response.eventLog);
        await this.getEvents();
        this.event = { ...this.event_default };
        this.event_selected = "";
        this.typeAlert = "success";
        this.messageAlert = "Evento salvo com sucesso";
        this.showAlert = true;
      } catch (error) {
        console.log(error.message);
        this.typeAlert = "error";
        this.messageAlert =
          "Não foi possível criar o Evento, tente novamente mais tarde";
        this.showAlert = true;
      } finally {
        this.loading = false;
      }
    },
    async put(id, data) {
      this.loading = true;
      try {
        let myHeaders = new Headers({
          "Content-Type": "application/json",
        });
        let res = await fetch(`${URL}event-log/${id}`, {
          method: "PUT",
          headers: myHeaders,
          body: JSON.stringify(data),
        });
        if (!res.ok) {
          throw new Error(res.message);
        }
        let response = await res.json();
        await this.saveCompanies(response.eventLog);
        await this.getEvents();
        this.event = { ...this.event_default };
        this.event_selected = "";
        this.typeAlert = "success";
        this.messageAlert = "Evento salvo com sucesso";
        this.showAlert = true;
      } catch (error) {
        console.log(error.message);
        this.typeAlert = "error";
        this.messageAlert =
          "Não foi possível editar o Evento, tente novamente mais tarde";
        this.showAlert = true;
      } finally {
        this.loading = false;
      }
    },
    async saveUpload() {},
    async saveCompanies(event) {
      // data.files = this.files;
      let data = [];
      if (this.event.type !== 3) {
        data = this.companies
          .filter((item) => item.check != false)
          .map((item) => ({
            id: item.envent_log_has_company_id,
            event_log_id: event.id,
            company_id: item.id,
            document: item.document,
            parts: 0,
            amount: this.getAmount(item),
          }));
      } else {
        data = this.companies
          .filter((item) => item.parts != 0 && item.parts != "")
          .map((item) => ({
            id: item.envent_log_has_company_id,
            event_log_id: event.id,
            company_id: item.id,
            document: item.document,
            parts: item.parts,
            amount: this.getAmount(item),
          }));
      }
      // console.log(data);
      this.loading = true;
      try {
        let myHeaders = new Headers({
          "Content-Type": "application/json",
        });
        let res = await fetch(`${URL}event-log-company`, {
          method: "POST",
          headers: myHeaders,
          body: JSON.stringify(data),
        });
        if (!res.ok) {
          throw new Error(res.message);
        }
        // let response = await res.json();
        // console.log(response);
        this.companies = [];
        this.checkAllLabel = "Selecionar Todos";
        this.checkAllIcon = "mdi-checkbox-marked-outline";
        this.checkAllColor = "green darken-3";
      } catch (error) {
        console.log(error.message);
        this.typeAlert = "error";
        this.messageAlert =
          "Não foi possível salvar os dados de Rateio, tente novamente mais tarde";
        this.showAlert = true;
      } finally {
        this.loading = false;
      }
    },
    getTotal() {
      return this.getCountCompaniesChecked() > 0 ? this.event.value : "0.00";
    },
    getAmount(company) {
      if (!company.check && this.event.type !== 3) {
        return "0.00";
      } else if (
        (company.parts == 0 || company.parts == "") &&
        this.event.type === 3
      ) {
        return "0.00";
      }
      if (this.event.type == 1) {
        let total = this.companies
          .filter((item) => item.check != false)
          .reduce((prev, curr) => prev + parseFloat(curr.billing), 0);
        let value = parseFloat(this.event.value.replace(/,/gi, "."));
        return ((parseFloat(company.billing) / total) * value).toFixed(2);
      } else if (this.event.type == 2) {
        let total = this.companies.filter((item) => item.check != false).length;
        let value = parseFloat(this.event.value.replace(/,/gi, "."));
        return (value / total).toFixed(2);
      } else if (this.event.type == 3) {
        let total = this.companies
          .filter((item) => item.parts != 0 && item.parts != "")
          .map((item) => parseInt(item.parts))
          .reduce((prev, curr) => prev + curr, 0);
        let value = parseFloat(this.event.value.replace(/,/gi, "."));
        return ((parseInt(company.parts) / total) * value).toFixed(2);
      }
    },
    handleSelectEvent() {
      if (this.event_selected === null) {
        this.newEvent();
      }
      this.event = this.events.find((item) => item.id == this.event_selected);
      this.disabledFields = this.event.cancelled == 1;
      this.loadCompanies();
      this.changeChipEvent();
    },
    handleCancelEvent() {
      this.dialogCancelEvent = true;
    },
    async exportCompanies(type) {
      this.download = {
        name: "",
        link: "#",
      };
      this.linkDownload = false;
      let data = {};
      data.code = this.event.code;
      data.type = this.event.type;
      data.month_reference =
        this.event.type == 1 ? this.event.month_reference : "";
      data.year_reference =
        this.event.type == 1 ? this.event.year_reference : "";
      data.value = this.event.value;
      if (this.event.type !== 3) {
        data.companies = this.companies
          .filter((item) => item.check)
          .map((item) => ({ ...item, amount: this.getAmount(item) }));
      } else if (this.event.type === 3) {
        data.companies = this.companies
          .filter((item) => item.parts != 0 && item.parts != "")
          .map((item) => ({ ...item, amount: this.getAmount(item) }));
      }

      try {
        let myHeaders = new Headers({
          "Content-Type": "application/json",
        });
        let res = await fetch(`${URL}event-log/export/${type}`, {
          method: "POST",
          headers: myHeaders,
          body: JSON.stringify(data),
        });
        if (!res.ok) {
          throw new Error(res.message);
        }
        let response = await res.json();
        // console.log(response);
        this.download.name = response.nome;
        // this.download.link = `${URL_IMAGE}${response.url}`;
        this.download.link = `${URL}event-log/download/${response.nome}`;
        this.linkDownload = true;
      } catch (error) {
        console.log(error.message);
        this.typeAlert = "error";
        this.messageAlert =
          "Não foi possível gerar o arquivo para download, tente novamente mais tarde";
        this.showAlert = true;
      }
    },
    handleClickClear() {
      this.event_selected = "";
      this.event = { ...this.event_default };
      this.companies = [];
    },
    newEvent() {
      this.clearEvent();
    },
    clearEvent() {
      this.showAlert = false;
      let copyEvent = { ...this.event };
      this.event_selected = "";
      this.event = { ...this.event_default };
      this.event.month_billing = copyEvent.month_billing;
      this.event.year_billing = copyEvent.year_billing;
      this.companies = [];
      this.disabledFields = false;
      this.changeChipEvent();
    },
    getClassSelected(company) {
      if (this.event.type === 3) {
        return company.parts != 0 && company.parts != ""
          ? "yellow lighten-4"
          : "";
      } else if (this.event.type !== 3) {
        return company.check ? "yellow lighten-4" : "";
      }
    },
    closeDialogCancelEvent() {
      this.dialogCancelEvent = false;
    },
    async handleCancelEventClick() {
      this.dialogCancelEvent = false;
      this.loading = true;
      try {
        let response = await fetch(`${URL}event-log/cancel/${this.event.id}`);
        console.log(response);
        this.typeAlert = "success";
        this.messageAlert = "Evento cancelado com sucesso";
        this.showAlert = true;
        this.clearEvent();
        this.getEvents();
      } catch (error) {
        console.log(error.message);
        this.typeAlert = "error";
        this.messageAlert =
          "Não foi possível Cancelar o Evento, tente novamente mais tarde";
        this.showAlert = true;
      } finally {
        this.loading = false;
      }
    },
    changeChipEvent() {
      if (this.event_selected === "") {
        this.colorChipEvent = "orange darken-1";
        this.textChipEvent = "NOVO EVENTO";
        this.nameChipEvent = ""; //EVENTO: {{ event.code }}
        this.classChipEvent = "";
      } else if (this.event.cancelled) {
        this.colorChipEvent = "red";
        this.textChipEvent = "CANCELADO";
        this.nameChipEvent = `EVENTO: ${this.event.code}`; //EVENTO: {{ event.code }}
        this.classChipEvent = "red--text";
      } else if (
        this.companies.length > 0 &&
        this.companies.find((item) => item.document !== "") != undefined
      ) {
        this.colorChipEvent = "green";
        this.textChipEvent = "FATURADO";
        this.nameChipEvent = `EVENTO: ${this.event.code}`; //EVENTO: {{ event.code }}
        this.classChipEvent = "green--text";
      } else {
        this.colorChipEvent = "blue";
        this.textChipEvent = "EDIÇÃO";
        this.nameChipEvent = `EVENTO: ${this.event.code}`; //EVENTO: {{ event.code }}
        this.classChipEvent = "blue--text";
      }
    },
  },
};
</script>
<style scoped>
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  font-size: 11.5px;
}
.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  font-size: 12px !important;
}
#styled-input {
  height: 40px;
  font-size: 20pt;
}
.compact-form .fs-12 {
  transform: scale(0.8);
  transform-origin: left;
}
.v-data-table__wrapper table tfoot th {
  position: sticky;
  bottom: 0;
  background: #fff;
}
.v-data-table--dense > .v-data-table__wrapper > table > tbody > tr > td {
  height: 24px;
}
.v-data-table--dense
  > .v-data-table__wrapper
  > table
  > tbody
  > tr
  > td
  .v-input--selection-controls {
  margin-top: 4px;
  margin-bottom: 4px;
}
</style>
<style>
.text-field-uppercase input,
.text-field-uppercase textarea {
  text-transform: uppercase;
}
</style>
